/** Cookie storing last known CSS viewport width (px) for SSR on the next document request. */
const VIEWPORT_WIDTH_COOKIE_NAME = 'tn_vw';

const VIEWPORT_WIDTH_COOKIE_MAX_AGE_SEC = 60 * 60;

export { VIEWPORT_WIDTH_COOKIE_MAX_AGE_SEC, VIEWPORT_WIDTH_COOKIE_NAME };
